import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MdMenu,
  MdNewspaper,
  MdOutlineFactCheck,
  MdOutlineFeaturedPlayList,
  MdOutlineFullscreen,
  MdOutlineFullscreenExit,
} from "react-icons/md";

import user_placeholder from "../../assets/user-profile.jpg";
import useAuth from "../../hooks/useAuth";
import { getLanguage } from "../../utils/getLanguage";
import Button from "../Button";
import LanguageSwitcher from "../LanguageSwitcher";
import NotificationDropdown from "../NotificationDropdown";
import ThemeToggle from "../ThemeToggle";

const TeacherHeader = ({ toggleSidebar }) => {
  const user = useAuth();
  const { t } = useTranslation();
  const lang = getLanguage();

  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error enabling fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.error(`Error exiting fullscreen: ${err.message}`);
      });
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        document.exitFullscreen().catch((err) => {
          console.error(`Error exiting fullscreen: ${err.message}`);
        });
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <header className="items-center bg-white py-3 text-text shadow-md dark:bg-dark-surface dark:text-dark-text dark:shadow-none">
      <div className="container-fluid mx-auto flex items-center justify-between px-4 sm:px-6">
        <div className="flex flex-row items-center space-x-4">
          <Button
            variant="text"
            color="white"
            icon={<MdMenu size={26} />}
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
            className="group relative flex h-10 w-10 items-center justify-center"
          />
        </div>

        <div className="flex items-center space-x-1">
          <Button
            onClick={toggleFullscreen}
            icon={isFullscreen ? <MdOutlineFullscreenExit size={20} /> : <MdOutlineFullscreen size={20} />}
            variant="text"
            color="white"
          />
          <ThemeToggle />
          <LanguageSwitcher />
          <NotificationDropdown />
          <Menu
            menuButton={
              <MenuButton>
                <div className="flex items-center space-x-2 rounded-lg px-2 capitalize">
                  {user.img_uri ? (
                    <img
                      src={user.img_uri}
                      alt="User Avatar"
                      className="h-8 w-8 rounded-full border border-gray-400 object-cover"
                    />
                  ) : (
                    <img
                      src={user_placeholder}
                      alt="User Avatar"
                      className="h-8 w-8 rounded-full border border-gray-400 object-cover"
                    />
                  )}
                  <span
                    title={user?.username || user?.b12_email}
                    className="max-w-[22ch] truncate text-xs font-semibold text-[#535353] dark:text-white"
                  >
                    {user?.username || user?.b12_email}
                  </span>
                </div>
              </MenuButton>
            }
            transition
            align="end"
            menuClassName="rounded-lg p-1 bg-white dark:border-gray-700 dark:bg-[#2C3A4A]"
          >
            <a target="_blank" rel="noopener noreferrer">
              <MenuItem className="flex items-center gap-2 rounded-lg px-2 py-2 text-xs">
                <MdNewspaper size={20} className="" />
                {t("teacher_certificate")}
              </MenuItem>
            </a>

            {/* <a
              href={lang == "ar" ? "/static/Teacher_User_Manual_ar.pdf" : "/static/Teacher_User_Manual.pdf"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MenuItem className="flex items-center gap-2 rounded-lg px-2 py-2 text-xs">
                <MdOutlineFeaturedPlayList size={20} className="" />
                {t("user_manual")}
              </MenuItem>
            </a>
            <a
              href={
                lang == "ar" ? "/static/Assessment_Guidelines_ar.pdf" : "/static/Assessment_Guidelines.pdf"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <MenuItem className="flex items-center gap-2 rounded-lg px-2 py-2 text-xs">
                <MdOutlineFactCheck size={20} className="" />
                {t("assessment_guidelines")}
              </MenuItem>
            </a> */}
          </Menu>
        </div>
      </div>
    </header>
  );
};

export default TeacherHeader;
